import { render, staticRenderFns } from "./ReserveList.vue?vue&type=template&id=15489c89&scoped=true&"
import script from "./ReserveList.vue?vue&type=script&lang=ts&"
export * from "./ReserveList.vue?vue&type=script&lang=ts&"
import style0 from "./ReserveList.vue?vue&type=style&index=0&id=15489c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15489c89",
  null
  
)

export default component.exports